import React from "react";
import MainElement from "./components/mainElement/mainElement";
import "./App.css";

function App() {
  return (
    <div className="App">
      <MainElement />
    </div>
  );
}

export default App;
